import React, {Fragment} from 'react';
import TopNav from "../../layouts/navs/auth-topabout";
import MOGULHome from "./components/main/home1";
import SplashBanner from "../../layouts/banners/splash1";
import MOGULHome2 from "./components/main/home2";
import LandlordMain from "../landlords/components/main/index1";

const AboutPage = () => {
    return (
        <Fragment>
            <TopNav/>
            <MOGULHome/>
            <SplashBanner/>
            {/* <MOGULHome2/> */}
            <LandlordMain/>
        </Fragment>
    );
};

export default AboutPage;
